
export default {
    props: {
        machine: {
            type: Object,
            default: {}
        }
    },
    computed: {
        link() {
            return route('machines.show', this.machine.id)
        }
    }
}

